import Link from "next/link";
// console.log(MyData, 'sssss');
import style from "@/app/style/state.module.css";

function MainStates() {
  const services = [
    {
      id: "#1",
      title: "Texas",
      desc: "Covering 50+ Routes Around the States",
      image: "updattexas",
      link: "/states/car-service-texas",
    },

    {
      id: "#3",
      title: "Illinois",
      desc: "Covering 60+ Routes Around the States",
      image: "updateIllinois",
      link: "/states/car-service-illinois",
    },

    {
      id: "#4",
      title: "California",
      desc: "Covering 40+ Routes Around the States",
      image: "updateoffcalifonia",
      link: "/states/car-service-california",
    },
    {
      id: "#3",
      title: "Massachusetts",
      desc: "Covering 70+ Routes Around the States",
      image: "updatemassachusetts",
      link: "/states/car-service-massachusetts",
    },

    {
      id: "#4",
      title: "Georgia",
      desc: "Covering 40+ Routes Around the States",
      image: "updatGeorgia",
      link: "/states/georgia-car-service",
    },
    {
      id: "#3",
      title: "Florida",
      desc: "Covering 60+ Routes Around the States",
      image: "updatFlorida",
      link: "/states/car-service-florida",
    },

    {
      id: "#4",
      title: "Connecticut",
      desc: "Covering 50+ Routes Around the States",
      image: "updatConnecticut",
      link: "/states/connecticut-car-service",
    },
    {
      id: "#3",
      title: "New York",
      desc: "Covering 60+ Routes Around the States",
      image: "updatNewYork",
      link: "/states/car-service-new-york",
    },

    // {
    //   id: "#4",
    //   title: "Washington",
    //   desc: "Covering 70+ Routes Around the States",
    //   image: "updatWashington",
    //   link: "#",
    // },

    {
      id: "#4",
      title: "New Jersey",
      desc: "Covering 40+ Routes Around the States",
      image: "updatNewJersey",
      link: "/states/car-service-new-jersey",
    },
    {
      id: "#4",
      title: "Pennsylvania",
      desc: "Covering 60+ Routes Around the States",
      image: "updatPennsylvania",
      link: "/states/pennsylvania-car-service",
    },
    {
      id: "#4",
      title: "Colorado",
      desc: "Covering 70+ Routes Around the States",
      image: "ColoradoMainPage",
      link: "/states/colorado-car-service",
    },
  ];


  const sortedServices = services.sort((a, b) => a.title.localeCompare(b.title));

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div>
      <div className="mx-auto max-w-7xl">
        <div className="grid px-7 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {sortedServices.map((server, index) => {
            return (
              <Link href={server.link} onClick={scrollTop} key={index}>
                <div id={style.maincitysize} className={style[server.image]}>
                  <div className="mt-1 text-white">
                    <div className="px-4">
                      <h2 className="flex justify-start updatedheading text-white">
                        {server.title}
                      </h2>
                      <p className="text-left updatedparapremu text-white">
                        {server.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );


  // const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  // return (
  //   <div>
  //     <div className="mx-auto max-w-7xl">
  //       <div className="grid px-7 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 ">
  //         {services.map((server, index) => {
  //           return (
  //             // <>
  //             <Link href={server.link} onClick={scrollTop} key={index}>
  //               <div id={style.maincitysize} className={style[server.image]}>
  //                 <div className="    mt-1 text-white">
  //                   <div className="px-4  ">
  //                     <h2 className=" flex   justify-start updatedheading text-white">
  //                       {server.title}
  //                     </h2>
  //                     <p className=" text-left updatedparapremu text-white">
  //                       {server.desc}
  //                     </p>
  //                   </div>
  //                 </div>
  //               </div>
  //             </Link>
  //             // </>
  //           );
  //         })}
  //       </div>
  //     </div>
  //   </div>
  // );
}

export default MainStates;
